module.exports = __webpack_public_path__ + "static/media/Welpen02.dabac7c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Welpen02.jpg
// module id = 332
// module chunks = 0